import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Answer } from 'typings/filters'

type Values = Answer[]

const initialState: Values = []

const reviewFilterValuesSlice = createSlice({
  name: 'reviewFilterValues',
  initialState,
  reducers: {
    setReviewFilterValues(state, action: PayloadAction<Values>) {
      return [...action.payload]
    },
  },
})

export const { setReviewFilterValues } = reviewFilterValuesSlice.actions

export default reviewFilterValuesSlice.reducer
